import type React from 'react'

import { cx } from '@portal/styled-system/css'

import { useI18n } from '@/shared/lib/i18n'

import { useActiveLaw } from './provider/use-active-law'

type SelectCookiesButtonProps = {
    className?: string
    as?: React.ElementType
}

export function SelectCookiesButton({ className, as: Component = 'span' }: SelectCookiesButtonProps) {
    const { i18n } = useI18n()

    const activeLaw = useActiveLaw()

    return (
        <Component className={cx('cky-banner-element', className)}>
            {activeLaw === 'ccpa' ? i18n.LINK_LEGAL_COOKIES__SHORT_CCPA : i18n.LINK_LEGAL_COOKIES__SELECT}
        </Component>
    )
}
